import { Select } from "antd";
import { TaskStatuses } from "enums/taskStatuses";
import { useEnumDropdown } from "hooks/useEnumDropdown";
import { useIntl } from "react-intl";

type Props = {
  onChange: (value: string) => void;
  defaultOptionValue: string;
};

export const SelectTaskStatus = ({ defaultOptionValue, onChange }: Props) => {
  const { formatMessage } = useIntl();
  const dropDownTaskStatuses = useEnumDropdown(TaskStatuses, "taskStatus", false);
  const defaultOption = {
    label: formatMessage({ id: "select.taskStatus.defaultOption.label" }),
    value: defaultOptionValue,
  };
  const options = [defaultOption, ...dropDownTaskStatuses];

  return (
    <Select defaultValue={defaultOption.value} onChange={onChange} options={options} popupMatchSelectWidth={false} />
  );
};
